import { CameraMarkerOutlineIcon } from './CameraMarkerOutlineIcon';

/**
 * author: Simran
 * id FC72F661-E548-4755-9919-B9960175B831
 * name camera-marker-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-marker-outline.svg
 * tags
 * - Photography 
 * - Navigation 
 */
export const CameraLocationOutlineIcon = CameraMarkerOutlineIcon;
export default CameraLocationOutlineIcon